// assets/build-my-routine.js — Mirai Build My Routine wizard
(function () {
  'use strict';

  var market = window.MiraiMarket;
  var t = market.t;
  var STORAGE_KEY = document.getElementById('mirai-routine-wizard')?.dataset.preview === 'true' ? 'mirai-routine-design-preview' : 'mirai-routine-draft';
  STORAGE_KEY += ':' + market.country + ':' + market.currency + ':' + market.locale;
  var API_RECOMMEND = market.url('apps/subscriptions/routine/recommend');
  var API_SAVE = market.url('apps/subscriptions/routine/save');
  var API_SHOP_ANON = market.url('apps/subscriptions/routine/shop-anonymous');

  var INPUTS = [
    {
      key: 'skin_type',
      question: "What's your skin type?",
      options: [
        { value: 'oily',        label: 'Oily / Acne-Prone' },
        { value: 'combination', label: 'Combination' },
        { value: 'dry',         label: 'Dry' },
        { value: 'sensitive',   label: 'Sensitive / Reactive' },
        { value: 'normal',      label: 'Normal' },
        { value: 'mature',      label: 'Mature (40+)' },
      ],
    },
    {
      key: 'concern',
      question: "What's your main concern?",
      options: [
        { value: 'acne',         label: 'Acne & Breakouts' },
        { value: 'dark_spots',   label: 'Dark Spots & Hyperpigmentation' },
        { value: 'aging',        label: 'Fine Lines & Aging' },
        { value: 'redness',      label: 'Redness & Sensitivity' },
        { value: 'dehydration',  label: 'Dryness & Dehydration' },
        { value: 'texture',      label: 'Dullness & Uneven Texture' },
        { value: 'pores',        label: 'Visible Pores' },
      ],
    },
    {
      key: 'budget',
      question: 'Your budget for the full routine?',
      options: [
        { value: 'starter',  label: 'Starter',       sub: '$50-100' },
        { value: 'standard', label: 'Standard',      sub: '$100-200' },
        { value: 'premium',  label: "Editor's Best", sub: '$200+' },
      ],
    },
    {
      key: 'depth',
      question: 'How deep do you want to go?',
      options: [
        { value: 'essentials', label: 'Essentials',           sub: 'Cleanser, toner, moisturizer, SPF (4 products)' },
        { value: 'daily_glow', label: 'Daily Glow',           sub: '+ essence, serum, eye cream (7 products)' },
        { value: 'full_amspm', label: 'Full K-Beauty AM + PM', sub: '10 products, split routine' },
      ],
    },
  ];

  var STEP_LABELS = {
    cleanser: 'Cleanser', toner: 'Toner', essence: 'Essence', serum: 'Serum',
    eye_cream: 'Eye Cream', moisturizer: 'Moisturizer', sunscreen: 'Sunscreen',
    am_cleanser: 'AM Cleanser', am_toner: 'AM Toner', am_serum: 'AM Serum',
    am_eye: 'AM Eye Cream', am_moisturizer: 'AM Moisturizer', am_sunscreen: 'AM Sunscreen',
    pm_oil_cleanser: 'PM Oil Cleanser', pm_water_cleanser: 'PM Water Cleanser',
    pm_treatment: 'PM Treatment', pm_eye: 'PM Eye Cream', pm_moisturizer: 'PM Moisturizer',
  };

  var root = document.getElementById('mirai-routine-wizard');
  if (!root) return;
  var currency = market.currency;
  var money = market.money;
  var customerLoggedIn = root.dataset.customerLoggedIn === 'true';
  var saveAfterLogin = root.dataset.saveAfterLogin === '1';

  var state = loadState() || {
    inputs: { skin_type: null, concern: null, budget: null, depth: null },
    inputIdx: 0,
    recommendations: null,
    stepKeys: null,
    stepIdx: 0,
    selected: {},
  };

  function loadState() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; } }
  function saveState() { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
  function clearState() { localStorage.removeItem(STORAGE_KEY); }

  function show(screenName, attrs) {
    var screens = root.querySelectorAll('[data-screen]');
    for (var i = 0; i < screens.length; i++) {
      var s = screens[i];
      var match = s.dataset.screen === screenName;
      if (attrs) for (var k in attrs) if (s.dataset[k] !== attrs[k]) match = false;
      s.classList.toggle('mrb-screen--active', match);
    }
    window.MiraiLocalize?.(root);
    window.scrollTo(0, 0);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }


  function budgetLabel(value) {
    var ranges = {starter:[5000,10000],standard:[10000,20000],premium:[20000,null]};
    var bounds = ranges[value], low = market.convert(bounds[0]), high = bounds[1] && market.convert(bounds[1]);
    if (low === null) return t(value === 'starter' ? 'Starter' : value === 'standard' ? 'Standard' : "Editor's Best");
    return (currency === market.shopCurrency ? '' : '≈ ') + money(low) + (high ? ' – ' + money(high) : '+');
  }
  async function localizeRecommendations(steps) {
    const handles = [...new Set(Object.values(steps).flat().map(p=>p.handle))];
    const products = new Map();
    // Limit concurrent product reads, and do not offer unavailable market variants.
    for (let i=0;i<handles.length;i+=4) await Promise.all(handles.slice(i,i+4).map(async handle=>{
      try { products.set(handle, await market.product(handle)); } catch (_) { products.set(handle,null); }
    }));
    Object.keys(steps).forEach(key=>{
      steps[key] = steps[key].flatMap(p=>{
        const product=products.get(p.handle), variant=product?.variants?.find(v=>String(v.id)===String(p.variant_id));
        if (!variant?.available || !Number.isFinite(variant.price)) return [];
        return [Object.assign({},p,{title:product.title,price_cents:variant.price,image_url:variant.featured_image?.src||product.featured_image||p.image_url})];
      });
    });
    if(Object.values(steps).some(picks=>!picks.length)) throw Error('Market unavailable');
  }

  // --- Splash ---
  var startBtn = root.querySelector('[data-action="start"]');
  if (startBtn) startBtn.addEventListener('click', function () { state.inputIdx = 0; renderInput(); });

  // --- Inputs ---
  function renderInput() {
    var input = INPUTS[state.inputIdx];
    var section = root.querySelector('[data-screen="input"][data-input="' + input.key + '"]');
    section.innerHTML = ''
      + '<div class="mrb-screen-inner">'
      +   '<div class="mrb-progress-label">' + escapeHtml(t('Step {current} of {total}', {current:state.inputIdx + 1,total:4})) + '</div>'
      +   '<div class="mrb-progress"><div class="mrb-progress-fill" style="width:' + Math.round(((state.inputIdx + 1) / 4) * 100) + '%"></div></div>'
      +   '<h2 class="mrb-input-q">' + escapeHtml(t(input.question)) + '</h2>'
      +   '<div class="mrb-options">'
      +     input.options.map(function (o) {
              var sel = state.inputs[input.key] === o.value;
              return '<button class="mrb-option' + (sel ? ' mrb-option--selected' : '') + '" data-input-value="' + o.value + '">'
                + escapeHtml(t(o.label)) + (o.sub ? '<span class="mrb-option-sub">' + escapeHtml(input.key === 'budget' ? budgetLabel(o.value) : t(o.sub)) + '</span>' : '')
                + '</button>';
            }).join('')
      +   '</div>'
      +   '<div class="mrb-step-nav">'
      +     (state.inputIdx > 0 ? '<button class="mrb-btn mrb-btn--secondary" data-input-back>Back</button>' : '<span></span>')
      +     '<button class="mrb-btn mrb-btn--primary" data-input-next' + (state.inputs[input.key] ? '' : ' disabled') + '>Next</button>'
      +   '</div>'
      + '</div>';

    section.querySelectorAll('[data-input-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('[data-input-value]').forEach(function (b) { b.classList.remove('mrb-option--selected'); b.setAttribute('aria-pressed','false'); });
        btn.classList.add('mrb-option--selected'); btn.setAttribute('aria-pressed','true');
        state.inputs[input.key] = btn.dataset.inputValue;
        section.querySelector('[data-input-next]').disabled = false;
        saveState();
      });
    });

    var backBtn = section.querySelector('[data-input-back]');
    if (backBtn) backBtn.addEventListener('click', function () { state.inputIdx -= 1; renderInput(); });

    var nextBtn = section.querySelector('[data-input-next]');
    nextBtn.addEventListener('click', function () {
      if (state.inputIdx < INPUTS.length - 1) {
        state.inputIdx += 1;
        saveState();
        renderInput();
      } else {
        saveState();
        fetchRecommendations();
      }
    });

    section.querySelectorAll('[data-input-value]').forEach(function(b){b.setAttribute('aria-pressed', String(b.classList.contains('mrb-option--selected')));});
    show('input', { input: input.key });
  }

  // --- Loading + fetch ---
  function fetchRecommendations() {
    show('loading');
    fetch(API_RECOMMEND, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(state.inputs),
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(async function (data) {
        await localizeRecommendations(data.steps);
        state.recommendations = data.steps;
        state.stepKeys = Object.keys(data.steps);
        state.stepIdx = 0;
        saveState();
        renderStep();
      })
      .catch(function (err) {
        var loading = root.querySelector('[data-screen="loading"]');
        loading.innerHTML = '<div class="mrb-screen-inner mrb-loading"><p>' + escapeHtml(t("Sorry, we couldn't build your routine.")) + '</p><a href="' + market.url('pages/build-my-routine') + '">' + escapeHtml(t('Try again')) + '</a></div>';
      });
  }

  // --- Steps ---
  function renderStep() {
    var key = state.stepKeys[state.stepIdx];
    var picks = state.recommendations[key] || [];
    var section = root.querySelector('[data-screen="step"]');
    var totalSteps = state.stepKeys.length;
    var selected = state.selected[key];
    var label = STEP_LABELS[key] || key;

    section.innerHTML = ''
      + '<div class="mrb-screen-inner">'
      +   '<div class="mrb-progress-label">' + escapeHtml(t('Step {current} of {total}', {current:state.stepIdx + 1,total:totalSteps})) + '</div>'
      +   '<div class="mrb-progress"><div class="mrb-progress-fill" style="width:' + Math.round(((state.stepIdx + 1) / totalSteps) * 100) + '%"></div></div>'
      +   '<div class="mrb-step-header">'
      +     '<div class="mrb-step-eyebrow">Pick your</div>'
      +     '<h2 class="mrb-step-title">' + escapeHtml(t(label)) + '</h2>'
      +   '</div>'
      +   '<div class="mrb-product-list">'
      +     picks.map(function (p) {
              var sel = selected && selected.handle === p.handle;
              return '<button class="mrb-product-card' + (sel ? ' mrb-product-card--selected' : '') + '" data-pick="' + escapeHtml(p.handle) + '">'
                + '<img class="mrb-product-img" src="' + escapeHtml(p.image_url || '') + '" alt="" onerror="this.style.background=\'#EDE3D2\';this.src=\'\';">'
                + '<div class="mrb-product-info">'
                +   '<div class="mrb-product-vendor">' + escapeHtml(p.vendor || '') + '</div>'
                +   '<div class="mrb-product-title">' + escapeHtml(p.title) + '</div>'
                +   '<div class="mrb-product-price">' + money(p.price_cents) + '</div>'
                +   (p.why && market.locale === 'en' ? '<div class="mrb-product-why">' + escapeHtml(p.why) + '</div>' : '')
                + '</div>'
              + '</button>';
            }).join('')
      +   '</div>'
      +   '<div class="mrb-step-nav">'
      +     '<button class="mrb-btn mrb-btn--secondary" data-step-back>Back</button>'
      +     '<button class="mrb-btn mrb-btn--primary" data-step-next' + (selected ? '' : ' disabled') + '>Next</button>'
      +   '</div>'
      + '</div>';

    section.querySelectorAll('[data-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.pick;
        var pick = picks.find(function (p) { return p.handle === handle; });
        state.selected[key] = Object.assign({}, pick, { step: key });
        saveState();
        section.querySelectorAll('[data-pick]').forEach(function (b) { b.classList.remove('mrb-product-card--selected'); b.setAttribute('aria-pressed','false'); });
        btn.classList.add('mrb-product-card--selected'); btn.setAttribute('aria-pressed','true');
        section.querySelector('[data-step-next]').disabled = false;
      });
    });

    section.querySelector('[data-step-back]').addEventListener('click', function () {
      if (state.stepIdx === 0) { state.inputIdx = INPUTS.length - 1; renderInput(); return; }
      state.stepIdx -= 1; saveState(); renderStep();
    });

    section.querySelector('[data-step-next]').addEventListener('click', function () {
      if (state.stepIdx < totalSteps - 1) { state.stepIdx += 1; saveState(); renderStep(); }
      else { renderSummary(); }
    });

    section.querySelectorAll('[data-pick]').forEach(function(b){b.setAttribute('aria-pressed',String(b.classList.contains('mrb-product-card--selected')));});
    show('step');
  }

  // --- Summary ---
  function renderSummary() {
    var section = root.querySelector('[data-screen="summary"]');
    var picks = state.stepKeys.map(function (k) { return state.selected[k]; }).filter(Boolean);
    var subtotal = picks.reduce(function (s, p) { return s + p.price_cents; }, 0);
    var discounted = Math.round(subtotal * 0.85);

    section.innerHTML = ''
      + '<div class="mrb-screen-inner mrb-summary">'
      +   '<h2>Your routine is ready</h2>'
      +   '<div class="mrb-summary-list">'
      +     picks.map(function (p) {
              return '<div class="mrb-summary-row">'
                + '<img src="' + escapeHtml(p.image_url || '') + '" alt="" onerror="this.style.background=\'#EDE3D2\';this.src=\'\';">'
                + '<div><div class="mrb-summary-step">' + escapeHtml(t(STEP_LABELS[p.step] || p.step)) + '</div><div class="mrb-summary-name">' + escapeHtml(p.title) + '</div></div>'
                + '<div class="mrb-summary-price">' + money(p.price_cents) + '</div>'
              + '</div>';
            }).join('')
      +   '</div>'
      +   '<div class="mrb-totals">'
      +     '<div class="mrb-totals-row"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>'
      +     '<div class="mrb-totals-row"><span>Bundle discount (15%)</span><span>−' + money(subtotal-discounted) + '</span></div>'
      +     '<div class="mrb-totals-row mrb-totals-row--final"><span>Estimated total</span><span>' + money(discounted) + '</span></div>'
      +   '</div>'
      +   '<p class="mrb-price-note">' + escapeHtml(t('Prices in {currency}. Final prices and availability confirmed at checkout.',{currency:currency})) + '</p>'
      +   '<div class="mrb-cta-stack">'
      +     '<button class="mrb-btn mrb-btn--primary mrb-btn--full mrb-btn--lg" data-action="shop">Shop this routine · ' + money(discounted) + '</button>'
      +     '<button class="mrb-btn mrb-btn--secondary mrb-btn--full" data-action="save">Save to My Mirai</button>'
      +     '<button class="mrb-btn mrb-btn--text" data-action="edit">Review my choices</button>'
      +   '</div>'
      + '</div>';

    section.querySelector('[data-action="shop"]').addEventListener('click', function () { doShop(picks); });
    section.querySelector('[data-action="save"]').addEventListener('click', function () { doSave(picks); });
    section.querySelector('[data-action="edit"]').addEventListener('click', function(){state.stepIdx=0;renderStep();});

    show('summary');
  }

  function doShop(picks) {
    var endpoint = customerLoggedIn ? API_SAVE : API_SHOP_ANON;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inputs: state.inputs, picks: picks }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.cart_url) throw new Error(data.error || 'unknown');
        clearState();
        window.location.href = market.url(data.cart_url);
      })
      .catch(function (err) { alert(t('Sorry, something went wrong. Please try again.')); });
  }

  function doSave(picks) {
    if (!customerLoggedIn) {
      var ret = market.url('pages/build-my-routine?save_after_login=1');
      window.location.href = market.url('account/login') + '?return_url=' + encodeURIComponent(ret);
      return;
    }
    fetch(API_SAVE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inputs: state.inputs, picks: picks }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'unknown');
        var el = document.querySelector('[data-code-placeholder]');
        if (el) el.textContent = data.routine.discount_code;
        alert(t('Saved! Your code is {code}',{code:data.routine.discount_code}));
      })
      .catch(function (err) { alert(t('Save failed. Please try again.')); });
  }

  // --- Boot ---
  if (saveAfterLogin && state.stepKeys && state.stepIdx >= state.stepKeys.length - 1) {
    renderSummary();
    setTimeout(function () {
      var picks = state.stepKeys.map(function (k) { return state.selected[k]; }).filter(Boolean);
      doSave(picks);
    }, 500);
  } else if (state.recommendations && state.stepKeys) {
    show('loading');
    localizeRecommendations(state.recommendations).then(function(){
      Object.keys(state.selected).forEach(function(key){const old=state.selected[key];const current=state.recommendations[key]?.find(p=>String(p.variant_id)===String(old.variant_id));if(current)state.selected[key]=Object.assign({},current,{step:key});else delete state.selected[key];});
      saveState(); renderStep();
    }).catch(function(){clearState();show('splash');});
  }
})();
